export * from './env';
export * from './universal-module';
export * from './proxy-document';
export * from '../common';
export * from '../lib';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
